import { push } from 'react-router-redux';
import { createAction } from 'redux-actions';
import { openGlobalModal, closeGlobalModal } from 'actions/modal';

import storage from 'util/storage';
import { setCookie, delCookie } from 'util/cookie';

import { wrapFetch, wrapFetchAuth } from './endpoint';
import { getMemberData } from './member';
import { toggleLoading } from './global';


export const loadConfig = createAction('LOAD_CONFIG', config => config);

const updateAccessToken = createAction(
	'UPDATE_ACCESS_TOKEN',
	({ status, message, data }, loginType) => {
		const token = {
			accessToken: '',
			endAt: '',
			expiresIn: '',
			refreshToken: '',
		};
		let type = '';

		if (status === 200 || status === 201) {
			const expireMS = data.expires_in * 1000;

			token.accessToken = data.access_token;
			token.endAt = new Date().getTime() + expireMS;
			token.expiresIn = expireMS;
			token.refreshToken = data.refresh_token;
			type = loginType;

			if (process.env.NODE_ENV === 'production') {
				setCookie(JSON.stringify(token), 'yuanyu.tw', 30);
			} else if (process.env.NODE_ENV === 'development') {
				setCookie(JSON.stringify(token), '25demo.com', 30);
			} else {
				setCookie(JSON.stringify(token), 'localhost', 30);
			}
		}

		storage.setItem('token', JSON.stringify(token));
		storage.setItem('type', loginType);

		return {
			token,
			type,
			status,
			message,
		};
	},
);

const toggleEmailExist = createAction('TOGGLE_EMAIL_EXIST', toggle => ({ toggle }));

export const signupNormal = createAction('SIGNUP_NORMAL', (email, password) => async dispatch => {
	const data = { email, password };
	dispatch(toggleLoading(true));
	const result = await wrapFetch('api/web/auth/signUp', {
		method: 'POST',
		body: JSON.stringify(data),
	});

	dispatch(updateAccessToken(result, 'normal'));
	dispatch(toggleLoading(false));

	if (result.status === 200 || result.status === 201) {
		dispatch(toggleEmailExist(false));
		dispatch(push('/member'));
		dispatch(openGlobalModal('signupVerificationSend'));
	} else if (result.status === 400 && result.message === 'duplicate email') {
		dispatch(toggleEmailExist(true));
	}
});

export const logout = createAction('LOGOUT', () => async (dispatch, getState) => {
	const { routing: { locationBeforeTransitions: { query: { referral } } } } = getState();
	const { status } = await wrapFetchAuth('api/web/auth/logout', {
		method: 'POST',
		body: {},
	});

	if (status === 200) {
		storage.removeItem('token');
		storage.removeItem('type');
		if (process.env.NODE_ENV === 'production') {
			delCookie('olympus-token', '.yuanyu.tw');
		} else if (process.env.NODE_ENV === 'development') {
			delCookie('olympus-token', '.25demo.com');
		} else {
			delCookie('olympus-token', 'localhost');
		}
		if (referral && referral !== '') {
			dispatch(push(`/login?referral=${referral}`));
		} else {
			dispatch(push('/login'));
		}
	}
});

export const memberDataComplete = createAction('MEMBER_DATA_COMPLETE', () => async dispatch => {
	const { status, message, data } = await wrapFetchAuth('api/web/user/me', {
		method: 'GET',
	});
	if (status === 200) {
		if (data.name !== '' && data.name !== null && data.email_verify === 1 && data.mobile_verify === 1) {
			dispatch(push('/product'));
		} else {
			dispatch(push('/member'));
		}
	} else if (status === 401 && (message === 'Access token expired' || message === 'Access token has been revoked')) {
		dispatch(logout());
	}
});

export const loginNormal = createAction('LOGIN_NORMAL', (email, password, referral) => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetch('api/web/auth/login', {
		method: 'POST',
		body: JSON.stringify({ email, password }),
	});
	dispatch(toggleLoading(false));

	dispatch(updateAccessToken(result, 'normal'));
	if (result.status === 200) {
		if (referral === '') {
			dispatch(memberDataComplete());
		} else if (referral === 'EC') {
			if (process.env.NODE_ENV === 'production') {
				window.location.href = 'https://shop.yuanyu.tw/';
			} else {
				window.location.href = 'https://shop-yuanyu.25demo.com/';
			}
		} else if (referral === 'course') {
			dispatch(push('/course'));
		}
		dispatch(getMemberData());
		return {
			loginErr: false,
		};
	} else if (result.status === 400 || result.status === 401) {
		return {
			loginErr: true,
		};
	}
	return {};
});

export const loginTransfer = createAction('LOGIN_TRANSFER', (email, password, id, status) => async dispatch => {
	dispatch(toggleLoading(true));
	const result = await wrapFetch('api/web/auth/login', {
		method: 'POST',
		body: JSON.stringify({ email, password }),
	});
	dispatch(toggleLoading(false));

	dispatch(updateAccessToken(result, 'normal'));

	if (result.status === 200 || result.status === 201) {
		dispatch(push(`/product/transfer/${id}?status=${status}`));
		dispatch(getMemberData());
		return {
			loginErr: false,
		};
	} else if (result.status === 401) {
		return {
			loginErr: true,
		};
	}
	return {};
});

export const getFacebookEmailandID = createAction('GET_FACEBOOK_DATA', (email, id) => async () => ({
	bindType: 'facebook',
	fbEmail: email,
	fbId: id,
}));

export const loginFacebook = createAction('LOGIN_FACEBOOK', (token, referral) => async dispatch => {
	const result = await wrapFetch('api/web/auth/fbLogin', {
		method: 'POST',
		body: JSON.stringify({ token }),
	});

	dispatch(updateAccessToken(result, 'facebook'));

	if (result.status === 200 || result.status === 201) {
		dispatch(getMemberData());
		if (referral === '') {
			dispatch(memberDataComplete());
		} else if (referral === 'EC') {
			if (process.env.NODE_ENV === 'production') {
				window.location.href = 'https://shop.yuanyu.tw/';
			} else {
				window.location.href = 'https://shop-yuanyu.25demo.com/';
			}
		} else if (referral === 'course') {
			dispatch(push('/course'));
		}
	} else if (result.status === 400) {
		dispatch(getFacebookEmailandID(result.data.email, result.data.fb_id));
		dispatch(push('/login'));
		dispatch(openGlobalModal('loginEmailConfirm'));
	}
});

export const getGoogleEmailandID = createAction('GET_GOOGLE_DATA', (email, id) => async () => ({
	bindType: 'google',
	googleEmail: email,
	googleId: id,
}));

export const loginGoogle = createAction('LOGIN_GOOGLE', (token, referral) => async dispatch => {
	const result = await wrapFetch('api/web/auth/googleLogin', {
		method: 'POST',
		body: JSON.stringify({ token }),
	});

	if (result.status === 200 || result.status === 201) {
		dispatch(updateAccessToken(result, 'google'));
		dispatch(getMemberData());
		if (referral === '') {
			dispatch(memberDataComplete());
		} else if (referral === 'EC') {
			if (process.env.NODE_ENV === 'production') {
				window.location.href = 'https://shop.yuanyu.tw/';
			} else {
				window.location.href = 'https://shop-yuanyu.25demo.com/';
			}
		} else if (referral === 'course') {
			dispatch(push('/course'));
		}
	} else if (result.status === 400) {
		dispatch(getGoogleEmailandID(result.data.email, result.data.google_id));
		dispatch(push('/login'));
		dispatch(openGlobalModal('loginEmailConfirm'));
	}
});

export const bindSocial = createAction('BIND_SOCIAL', (type, email, id) => async dispatch => {
	let data = {};
	if (type === 'google') {
		data = { email, google_id: id };
	} else if (type === 'facebook') {
		data = { email, fb_id: id };
	}

	const result = await wrapFetch('api/web/auth/updateSocial', {
		method: 'POST',
		body: JSON.stringify(data),
	});
	if (result.status === 200) {
		dispatch(push('/member'));
		dispatch(closeGlobalModal('loginEmailConfirm'));
	} else if (result.status === 201) {
		dispatch(push('/member'));
		dispatch(closeGlobalModal('loginEmailConfirm'));
	}
});

export const forgetPassword = createAction('FORGET_PASSWORD', (type, value) => async dispatch => {
	let data = {};
	if (type === 'email') {
		data = { type, email: value };
	} else if (type === 'mobile') {
		data = { type, mobile: value };
	}
	const result = await wrapFetch('api/web/auth/sendResetPassword', {
		method: 'POST',
		body: JSON.stringify(data),
	});

	if (result.status === 200) {
		if (type === 'email') {
			dispatch(push('/login'));
			dispatch(openGlobalModal('forgetEmailSend'));
		} else if (type === 'mobile') {
			dispatch(push(`/forget?status=code&mobile=${value}`));
		}
		return {
			forgetErr: false,
		};
	} else if (result.status === 404) {
		return {
			forgetErr: true,
		};
	} else if (result.status === 401 && result.message === 'less than a minute') {
		dispatch(openGlobalModal('codeVerifyMinute'));
	}
	return {};
});

export const resetPassword = createAction('RESET_PASSWORD', (code, token, mobile, password) => async dispatch => {
	let data = {};
	if (token !== '') {
		data = { email_code: code, email_token: token, new_password: password };
	} else if (mobile !== '') {
		data = { mobile_code: code, mobile, new_password: password };
	}
	const result = await wrapFetch('api/web/auth/resetPassword', {
		method: 'POST',
		body: JSON.stringify(data),
	});

	if (result.status === 200) {
		dispatch(openGlobalModal('resetPasswordSuccess'));
	} else if (result.status === 401 && result.message === 'verify code expired') {
		dispatch(openGlobalModal('resetPasswordExpired'));
	}
});

export const verifyMobileCode = createAction('VERIFY_MOBILE_CODE', (mobile, mobileCode) => async dispatch => {
	const result = await wrapFetch('api/web/auth/checkMobileCode', {
		method: 'POST',
		body: JSON.stringify({ mobile, mobile_code: mobileCode }),
	});

	if (result.status === 200) {
		dispatch(push(`/forget/reset?code=${result.data.mobile_code}&mobile=${result.data.mobile}`));
	} else {
		return { mobileVerifyFail: true };
	}
	return {};
});



// WEBPACK FOOTER //
// ./src/actions/auth.js